"use client";

import { Input } from "@/components/ui/input";

interface ParamInputsProps {
  params: string[];
  values: Record<string, string>;
  onChange: (values: Record<string, string>) => void;
  disabled?: boolean;
}

export function ParamInputs({ params, values, onChange, disabled }: ParamInputsProps) {
  if (params.length === 0) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      {params.map((name) => (
        <Input
          key={name}
          className="w-40"
          placeholder={name}
          value={values[name] ?? ""}
          onChange={(e) => onChange({ ...values, [name]: e.target.value })}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
